module.exports = __webpack_public_path__ + "static/media/izlozba (2).e34b0a2d.jpg";